import { AgentPromptsList } from './AgentPromptsList';

interface AgentPromptsTabProps {
  agentId: string;
  onAssignPrompt: () => void;
}

export function AgentPromptsTab({ agentId, onAssignPrompt }: AgentPromptsTabProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white">
          Assigned Prompts
        </h3>
        <button
          type="button"
          onClick={onAssignPrompt}
          className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700"
        >
          + Assign Prompt
        </button>
      </div>
      <AgentPromptsList agentId={agentId} />
    </div>
  );
}
